// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Gopher', 'Manrope', sans-serif;
  background-color: #f1ffcf;
  color: #333333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app {
  max-width: 1200px;
  margin: 40px auto 0;
}

 .loading {
  text-align: center;
  font-size: 2em;
  font-weight: bold;
  margin: 40px auto;
 }

.region {
  text-align: center;
  font-size: 3.25em;
  font-weight: bold;
  text-align: center;
  margin: 10px 0px 0px;
}

.bignumbers {
  display: flex;
  justify-content: space-evenly;
  margin: 60px auto;
  padding: 0px 20px;
  text-align: center;
}

.bignumber {
  background-color: rgb(12, 236, 145);
  border-radius: 1000px;
  min-width: 280px;
  padding: 22px;
  font-size: 3.25em;
  font-weight: bold;
}

.subtext {
  text-transform: uppercase;
  font-size: 1.7em;
  margin-top: 20px;
  font-weight: bold;
}

.prompt {
  font-size: 1.43em;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1000px;
  justify-content: space-evenly;
  padding: 0px 15px;
  text-align: center;
}

.prompt {
  margin: 30px auto;
}

.prompt a, .prompt .share {
  text-decoration: underline;
  cursor: pointer;
  text-underline-offset: 0.3em;
  color: unset;
  font-weight: bold;
}

.break {
  border-bottom: 2px solid #14343e44;
  max-width: 80vw;
  margin: 50px auto 30px;
}

.sort {
  display: flex;
  justify-content: space-evenly;
  max-width: 700px;
  align-items: center;
  margin: 50px auto;
  font-weight: bold;
  font-size: 1.56em;
}

.sort button {
  padding: 10px 20px;
  margin: 10px 10px;
  border: none;
  background-color: #14343e06;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  border-radius: 1000px;
  cursor: pointer;
}

.sort button.active {
  background: #fff;
}

.schools_container {
  margin: 20px 0;
}

table.schools {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  font-weight: bold;
}

.schools th, .schools td {
  padding: 10px;
  text-align: left;
}

.schools th {
  font-size: 2.2em;
  padding: 20px;
  text-transform: uppercase;
  text-align: center;
}

.schools td {
  text-align: center;
  padding: 6px 3px;
  font-size: 1.5em;
}

.schools a {
  text-decoration: none;
  color: inherit;
}

.schools a img {
  height: 12px;
}

.footer {
  margin-top: 80px;
  background-color: #14343e;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px;
  font-size: 1.56em;
}

.footer a {
  color: #fff;
  text-decoration: none;
}

.footer img {
  height: 24px;
  margin-left: 10px;
}

.region_small {
  text-align: center;
  padding: 30px 20px 0;
  font-size: 1.3em;
}

.region_small a {
  color: inherit;
  text-decoration: none;
}

.region_small a:hover {
  text-decoration: underline;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .region {
    font-size: 2.3em;
    margin: 30px 0px 0px;
    padding: 0 15px;
  }

  .bignumbers {
    flex-direction: column;
    align-items: center;
    gap: 40px
  }

  .bignumber {
    font-size: 2.5em;
        padding: 15px;
  }

  .prompt {
    flex-direction: column;
    gap: 20px;
  }

  .sort {
    flex-direction: column;
    margin: 30px auto;
  }

  .schools th {
    font-size: 1.6em;
    padding: 15px 10px;
  }

  .schools td {
    font-size: 1.2em;
    padding: 10px;
  }

  .footer {
    flex-direction: column;
    gap: 20px;
    text-align: center;
    padding: 30px 20px;
  }

  .region_small {
    font-size: 1.3em;
    padding: 20px 15px 0;
  }
}

@media (max-width: 480px) {
  .schools_container {
    margin: 20px 10px;
    overflow-x: auto;
  }

  .schools {
    min-width: 300px;
  }

  .bignumber {
    margin: 0 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;CAEC;EACC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;CAClB;;AAED;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE;IACE,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB;EACF;;EAEA;IACE,gBAAgB;QACZ,aAAa;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Gopher', 'Manrope', sans-serif;\n  background-color: #f1ffcf;\n  color: #333333;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.app {\n  max-width: 1200px;\n  margin: 40px auto 0;\n}\n\n .loading {\n  text-align: center;\n  font-size: 2em;\n  font-weight: bold;\n  margin: 40px auto;\n }\n\n.region {\n  text-align: center;\n  font-size: 3.25em;\n  font-weight: bold;\n  text-align: center;\n  margin: 10px 0px 0px;\n}\n\n.bignumbers {\n  display: flex;\n  justify-content: space-evenly;\n  margin: 60px auto;\n  padding: 0px 20px;\n  text-align: center;\n}\n\n.bignumber {\n  background-color: rgb(12, 236, 145);\n  border-radius: 1000px;\n  min-width: 280px;\n  padding: 22px;\n  font-size: 3.25em;\n  font-weight: bold;\n}\n\n.subtext {\n  text-transform: uppercase;\n  font-size: 1.7em;\n  margin-top: 20px;\n  font-weight: bold;\n}\n\n.prompt {\n  font-size: 1.43em;\n  margin: 0px auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 1000px;\n  justify-content: space-evenly;\n  padding: 0px 15px;\n  text-align: center;\n}\n\n.prompt {\n  margin: 30px auto;\n}\n\n.prompt a, .prompt .share {\n  text-decoration: underline;\n  cursor: pointer;\n  text-underline-offset: 0.3em;\n  color: unset;\n  font-weight: bold;\n}\n\n.break {\n  border-bottom: 2px solid #14343e44;\n  max-width: 80vw;\n  margin: 50px auto 30px;\n}\n\n.sort {\n  display: flex;\n  justify-content: space-evenly;\n  max-width: 700px;\n  align-items: center;\n  margin: 50px auto;\n  font-weight: bold;\n  font-size: 1.56em;\n}\n\n.sort button {\n  padding: 10px 20px;\n  margin: 10px 10px;\n  border: none;\n  background-color: #14343e06;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  border-radius: 1000px;\n  cursor: pointer;\n}\n\n.sort button.active {\n  background: #fff;\n}\n\n.schools_container {\n  margin: 20px 0;\n}\n\ntable.schools {\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  font-weight: bold;\n}\n\n.schools th, .schools td {\n  padding: 10px;\n  text-align: left;\n}\n\n.schools th {\n  font-size: 2.2em;\n  padding: 20px;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.schools td {\n  text-align: center;\n  padding: 6px 3px;\n  font-size: 1.5em;\n}\n\n.schools a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.schools a img {\n  height: 12px;\n}\n\n.footer {\n  margin-top: 80px;\n  background-color: #14343e;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 50px;\n  font-size: 1.56em;\n}\n\n.footer a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.footer img {\n  height: 24px;\n  margin-left: 10px;\n}\n\n.region_small {\n  text-align: center;\n  padding: 30px 20px 0;\n  font-size: 1.3em;\n}\n\n.region_small a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.region_small a:hover {\n  text-decoration: underline;\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n  .region {\n    font-size: 2.3em;\n    margin: 30px 0px 0px;\n    padding: 0 15px;\n  }\n\n  .bignumbers {\n    flex-direction: column;\n    align-items: center;\n    gap: 40px\n  }\n\n  .bignumber {\n    font-size: 2.5em;\n        padding: 15px;\n  }\n\n  .prompt {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .sort {\n    flex-direction: column;\n    margin: 30px auto;\n  }\n\n  .schools th {\n    font-size: 1.6em;\n    padding: 15px 10px;\n  }\n\n  .schools td {\n    font-size: 1.2em;\n    padding: 10px;\n  }\n\n  .footer {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n    padding: 30px 20px;\n  }\n\n  .region_small {\n    font-size: 1.3em;\n    padding: 20px 15px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .schools_container {\n    margin: 20px 10px;\n    overflow-x: auto;\n  }\n\n  .schools {\n    min-width: 300px;\n  }\n\n  .bignumber {\n    margin: 0 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
